import { Alert, AlertTitle, Box, Button, Divider, Modal, Typography } from '@mui/material';

const ReduxModal = ({ open, handleClose, title, message, severity = 'info' }) => {
    console.log('ReduxModal props:', { open, title, message, severity }); // 디버깅용 로그

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 1,
                    outline: 'none'  // 모달 외곽선 제거
                }}
            >
                <Alert
                    severity={severity}
                    variant="standard"
                    sx={{
                        '& .MuiAlert-message': {
                            width: '100%'
                        }
                    }}
                >
                    {title && (
                        <AlertTitle sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                            {title}
                        </AlertTitle>
                    )}
                    {message && (
                        <Typography
                            variant="body1"
                            component="div"
                            sx={{
                                mt: 1,
                                whiteSpace: 'pre-line' // 줄바꿈 처리를 위해 추가
                            }}
                        >
                            {message}
                        </Typography>
                    )}
                </Alert>

                <Divider sx={{ mt: 2, mb: 2 }} />

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="contained"
                        color={severity === 'error' ? 'error' : 'primary'}
                        onClick={handleClose}
                        size="medium"
                    >
                        확인
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ReduxModal; 